import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { _isId } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllProject(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Project,
      queryString:`Page=${page}&Size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async createProject(name:string,description?:string,budget?:number){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Project,
    },
    {
      userId:_isId,
      name:name,
      description:description,
      budget:budget
    });
    return await firstValueFrom(observable);
  }

  async updateProject(id,name:string,description?:string,budget?:number){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Project,
    },
    {
      id:id,
      userId:_isId,
      name:name,
      description:description,
      budget:budget
    });
    return await firstValueFrom(observable);
  }
  
  async getByIdProject(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Project
    },id);
    return await firstValueFrom(observable);
  }

  async createProjectFile(files:File[],id){
    const formData = new FormData();
    formData.append('ProjectId', id);
    if (files && files.length) {
      files.forEach((file, index) => {
        formData.append('FormFiles', file, file.name || `file${index}`);
      });
    }
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Project,
      action:"CreateProjectFile"
    },formData);
    return await firstValueFrom(observable);
  }

  async getByIdProjectFile(page,size,id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Project,
      queryString:`Page=${page}&Size=${size}&id=${id}`,
      action:"GetProjectFile"
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }

}
